import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description ProjectManager icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { ProjectManager } from '@sravni/design-system-icons'
 *
 * <ProjectManager />
 * ```
 */
var ProjectManager = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "ProjectManager", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.402 17.083h-1.666a.834.834 0 0 1-.834-.833v-1.667c0-.46.374-.833.834-.833h1.666c.46 0 .834.373.834.833v1.667c0 .46-.374.833-.834.833ZM10.736 7.658v6.092M11.57 17.083H9.904a.834.834 0 0 1-.834-.833v-1.667c0-.46.374-.833.834-.833h1.666c.46 0 .834.373.834.833v1.667c0 .46-.374.833-.834.833ZM5.736 17.083H4.07a.834.834 0 0 1-.834-.833v-1.667c0-.46.374-.833.834-.833h1.666c.46 0 .834.373.834.833v1.667c0 .46-.374.833-.834.833ZM14.198 7.658H7.273a2.371 2.371 0 0 1 0-4.741h6.925a2.371 2.371 0 0 1 0 4.741Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4.902 13.75v-1.667c0-.92.746-1.666 1.667-1.666h8.333c.921 0 1.667.745 1.667 1.666v1.667", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { ProjectManager };
//# sourceMappingURL=ProjectManager.js.map
